<template>
    <div class="Chat__footer">
        <textarea-autosize ref="messageInput"
                           v-model="message"
                           :min-height="50" :max-height="100"
                           :important="true"
                           rows="1" placeholder="Ecrivez votre message"
                           type="text" class="Chat__input"/>

        <button :disabled="loading" class="Chat__button" @click.prevent="handleSubmit" type="button">
            <i v-if="loading" class="fas fa-spinner fa-spin"></i>
            <span v-else>Envoyer</span>
        </button>
    </div>
</template>

<script>
    import {getters} from "../../store";

    export default {
        props: ['loading'],
        data: function(){
            return {
                message: ''
            }
        },
        computed: {
          openedDiscussionId: getters.openedDiscussionId
        },
        watch: {
            openedDiscussionId: function(){
                this.focus();
                this.message = '';
            }
        },
        methods: {
            handleSubmit: function(){
                this.$emit('submit', this.message);
                this.message = '';
            },
            focus: function(){
                let x = window.scrollX, y = window.scrollY;
                this.$refs.messageInput.$el.focus();
                window.scrollTo(x, y);
            }
        },
        mounted() {
            this.focus();
        }
    }
</script>
